<div class="pwd" [class.pwd--error]="errorText() !== null" [class.pwd--disabled]="disabledState()">
  @if (label(); as labelText) {
    <label class="pwd__label" [attr.for]="inputId()">{{ labelText }}</label>
  }
  <div class="pwd__field">
    <span class="pwd__icon pwd__icon--prefix" aria-hidden="true">
      <sz-icon name="lock" [size]="18" />
    </span>
    <input
      class="pwd__input"
      [id]="inputId()"
      [type]="type()"
      [placeholder]="placeholder()"
      [value]="value()"
      [disabled]="disabledState()"
      [attr.autocomplete]="autocomplete()"
      (input)="onInput($event)"
      (blur)="onBlur()" />
    <button
      type="button"
      class="pwd__toggle"
      [attr.aria-label]="toggleAriaLabel()"
      [attr.aria-pressed]="revealed()"
      (click)="toggleReveal()">
      <sz-icon [name]="revealed() ? 'eye-off' : 'eye'" [size]="18" />
    </button>
  </div>
  <div class="pwd__meta">
    @if (errorText(); as err) {
      <span class="pwd__error">{{ err }}</span>
    } @else if (helperText(); as helper) {
      <span class="pwd__helper">{{ helper }}</span>
    }
  </div>
</div>
